import * as React from 'react';
import styled from 'styled-components';
import { Colors } from '../../styles/theme';
import { Skeleton } from './JRCSkeleton';

/**
 * Props type for JRCLoader
 * @member color string based on theme.tsx colors
 * @member size size of the loader, default is s, 20px width
 */

interface JRCSpinnerProps {
    color?: Colors;
    size?: 's' | 'm' | 'l';
    className?: string;
    noMargin?: boolean;
}
interface JRCLoaderVariantProps {
    variant?: 'spinner' | 'skeleton';
}
export type JRCLoaderProps = JRCLoaderVariantProps & JRCSpinnerProps;

const sizeMap = {
    s: 20,
    m: 40,
    l: 60,
};

const Loader = styled.div<Required<JRCSpinnerProps>>`
    border: ${(props) => `${sizeMap[props.size] / 10}px solid transparent`};
    border-top: ${(props) => `${sizeMap[props.size] / 10}px solid ${props.theme.color[props.color]}`};
    border-radius: 50%;
    margin: ${(props) => (props.noMargin ? 0 : 'auto')};
    width: ${(props) => `${sizeMap[props.size]}px`};
    height: ${(props) => `${sizeMap[props.size]}px`};
    box-sizing: border-box;
    animation: spin 2s linear infinite;
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export const JRCLoader = ({
    color = 'primary',
    size = 's',
    variant = 'spinner',
    className,
    noMargin,
}: JRCLoaderProps) => {
    if (variant === 'skeleton') {
        return <Skeleton />;
    }
    return <Loader color={color} size={size} className={className || ''} noMargin={noMargin ?? false} />;
};
